import {
	CreateSurveyDTO,
	restRepository,
	SurveySubmitDTO,
	UpdateSurveyDTO,
} from "@onair/repositories";
import { RequestParams } from "@onair/repositories/rest-api-cms";

export interface GetSurveysParams {
	offset?: number;
	limit?: number;
	createdAt?: string;
	search?: string;
	ids?: string[];
}

export interface AdminGetSurveysParams extends GetSurveysParams {
	userId: string;
}

export interface GetSurveySubmissionsParams {
	surveyId: string;
	offset?: number;
	limit?: number;
	search?: string;
	fromDate?: string;
	toDate?: string;
	productIds?: string[];
}

export const getMySurveys = async (params: GetSurveysParams) => {
	const response = await restRepository.api.getMySurveys({
		...params,
		ids: params.ids?.join(","),
	});
	return response.data;
};

export const createSurvey = async (payload: CreateSurveyDTO) => {
	const response = await restRepository.api.createSurvey(payload);
	return response.data;
};

export const updateSurvey = async (id: string, payload: UpdateSurveyDTO) => {
	const response = await restRepository.api.updateSurvey(id, payload);
	return response.data;
};

export const getSurveyById = async (id: string, params?: RequestParams) => {
	try {
		const response = await restRepository.api.getSurveyById(id, params);
		return response.data;
	} catch (err) {}
};

export const getSurveySubmissions = async (
	params: GetSurveySubmissionsParams,
) => {
	const response = await restRepository.api.getSurveySubmissions(
		params.surveyId,
		{
			...params,
			productIds: params.productIds?.join(","),
		},
	);
	return response.data;
};

export const getSurveyLinkedProducts = async (surveyId: string) => {
	const response = await restRepository.api.getSurveyLinkedProducts(surveyId);
	return response.data;
};

export const softCreateSurvey = async (payload: CreateSurveyDTO) => {
	const response = await restRepository.api.createSurveyPreview(payload);
	return response.data;
};

export const deleteSurvey = async (id: string) => {
	const response = await restRepository.api.deleteSurvey(id);
	return response.data;
};

export const submissionSurvey = async (
	surveyId: string,
	payload: SurveySubmitDTO,
) => {
	const response = await restRepository.api.submitSurvey(surveyId, payload);
	console.log(response.data);
	return response.data;
};

export const getSurveysByUserId = async (params: AdminGetSurveysParams) => {
	try {
		const response = await restRepository.api.adminGetAllSurveys(
			params.userId,
			// @ts-ignore
			{
				...params,
				ids: params.ids?.join(","),
			},
		);
		return response.data;
	} catch (err) {}
};
